module.exports = __webpack_public_path__ + "d69ecb6145a26db0bb6d2246cecbba15.png";